<template>
  <div class="rolemanagetable">
    <el-table
      :data="tableData"
      style="width: 100%;padding:10px 10px 0 10px;"
      border>
      <el-table-column
        prop="createAtMY"
        label="创建时间"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="渠道名称"
      >
      </el-table-column>
      <el-table-column
        prop="template"
        label="渠道模板"
      >
        <template slot-scope="scope">
          <span>{{userTabletemplate[scope.row.template]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" width="120" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="配置"
        width="120"
      >
        <template slot-scope="scope">
          <span @click="seeClick(scope)" style="color: #5b9bd1;cursor: pointer;" class="tit" >点击查看</span>
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        width="300">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.cz === 1">
            <el-button @click="closeClick(scope)" type="text" class="btn" size="small">关闭</el-button>
            <span> / </span>
            <el-button type="text" class="btn" size="small">外链</el-button>
            <span> / </span>
            <el-button type="text" class="btn" size="small">二维码</el-button>
          </div> -->

          <div>
            <el-button @click="changeClick(scope)" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-edit-outline"></i>修改</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>关闭</el-button>
            <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>开启</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="removeClick(scope)" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button>
          </div>

          <!-- <div v-if="scope.row.cz === 3">
            <el-button @click="closeClick(scope)" type="text" class="btn" size="small">关闭</el-button>
          </div> -->
        </template>

          
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import {userTabletemplate} from '@/constants/tablecommon'
export default {
  name: 'rolemanagetable',
  props: {
    tableData:Array,
  },
  data(){
    return {
      isPush:1,
      userTabletemplate
      // tableData:[
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'全媒体推送渠道',
      //     mode:'路特全媒体V4'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'全媒体推送渠道',
      //     mode:'路特全媒体V4'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'全媒体推送渠道',
      //     mode:'路特全媒体V4'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'全媒体推送渠道',
      //     mode:'路特全媒体V4'
      //   },
      // ]
    }
  },
  methods:{
    openClick(scope){
      this.$emit('openPzClick',scope)
    },
    closeClick(scope){
      this.$emit('closeClick',scope)
    },
    changeClick(scope){
      this.$emit('changeClick',scope)
    },
    removeClick(scope){
      this.$emit('removeClick',scope)
    },
    seeClick(scope){
      this.$emit('seeClick',scope)
    },
  },
  created(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table{
  width: auto;
}
.el-table ::v-deep .cell .tit:hover{
  text-decoration: underline !important;
}
.btn:hover{
  text-decoration: underline;
}
</style>
